import { createStore } from 'redux';

import { createReducer, ITypeHaver } from './utils';
import { FileTemplate, mutateFilepath } from './file-template';
import { FilesState, IndexedFiles } from './file-types';
import { renamePathPrefix } from '@bit/bit.utils.fs.rename-path';

import {
	WRITE_FILE,
	SET_FILES,
	ADD_FOLDER,
	DEL_FILE,
	RENAME_FILE,
	HARD_RESET,
} from './actions';

const initialState: FilesState = {
	files: undefined,
};

const handlers = {
	[WRITE_FILE]: (state: FilesState, action: ITypeHaver): FilesState => {
		return updateFile(state, action);
	},
	[ADD_FOLDER]: (state: FilesState, action: ITypeHaver): FilesState => {
		const { fileId } = action as { type: string; fileId: string };
		const { files } = state;

		if (files && files[fileId]) {
			return state;
		}

		return {
			...state,
			files: {
				...state.files,
				[fileId + '/']: {},
			},
		};
	},
	[SET_FILES]: (state: FilesState, action: ITypeHaver): FilesState => {
		const { files } = action as {
			type: string;
			files: IndexedFiles;
		};
		return {
			...state,
			files: files,
		};
	},
	[HARD_RESET]: (state: FilesState, action: ITypeHaver): FilesState => {
		return initialState;
	},
	[DEL_FILE]: (state: FilesState, action: ITypeHaver): FilesState => {
		const { fileId } = action as { type: string; fileId: string };
		if (!state.files) return state;

		const remainingFileIds = Object.keys(state.files).filter(x => !x.startsWith(fileId));
		const nextFiles = Object.assign(
			{},
			...remainingFileIds.map(id => ({ [id]: state.files![id] }))
		);

		return {
			...state,
			files: nextFiles,
		};
	},

	[RENAME_FILE]: (state: FilesState, action: ITypeHaver): FilesState => {
		const { prevId, nextId } = action as { type: string; prevId: string; nextId: string };

		const { files } = state;
		if (!files) return state;

		const updatedFiles = Object.entries(files).map(([filepath, file]) => {
			const nextFilepath: string = renamePathPrefix(filepath, prevId, nextId);
			const nextFile = mutateFilepath(file, nextFilepath);

			return { [nextFilepath]: nextFile };
		});

		const nextFiles: IndexedFiles = Object.assign({}, ...updatedFiles);

		//OK NO.
		// NO STOP.
		// this is not the way.
		// use memfs.
		// observe state with memfs.toJSON().

		//* 1 day later *
		//OK.
		// memfs is horrible.
		// all hail KutnerFS
		// the fifth implementation of memfs in bit.dev
		// for the glory of Kutnerotszka!

		// 1 month later - implement ObjectFs as an adapter to node.fs
		// at least it's a bit component?

		return {
			...state,
			files: nextFiles,
		};
	},
};

function updateFile(state: FilesState, action: ITypeHaver) {
	const { fileId, content } = action as { fileId: string; content: string; type: string };

	const prevFiles = state.files || {};
	const prevFile = prevFiles[fileId] || new FileTemplate(fileId).toObj();

	const nextFiles = {
		...state.files,
		[fileId]: {
			...prevFile,
			source: content,
		},
	};

	return {
		...state,
		files: nextFiles,
	};
}

export default function createFileStore() {
	const reducer = createReducer<FilesState>(initialState, handlers);
	const store = createStore(reducer); //, applyMiddleware(logger));
	return store;
}
